module.exports = __webpack_public_path__ + "media/Video 4.3287bd92.mp4";